(function () {
  'use strict';

  if (window.__vetroCardAtcInit) return;
  window.__vetroCardAtcInit = true;

  var modal = document.getElementById('vetro-card-atc-modal');
  if (!modal) return;

  var titleEl = modal.querySelector('.vetro-card-atc-modal__title');
  var descriptionEl = modal.querySelector('.vetro-card-atc-modal__description');
  var sizesWrap = modal.querySelector('.vetro-card-atc-modal__sizes');
  var sizesLabel = modal.querySelector('.vetro-card-atc-modal__sizes-label');
  var sizeOptionsEl = modal.querySelector('.vetro-card-atc-modal__size-options');
  var submitBtn = modal.querySelector('.vetro-card-atc-modal__submit');

  var labels = {
    size: modal.getAttribute('data-label-size') || 'Size',
    add: modal.getAttribute('data-label-add') || 'Add to cart',
    soldOut: modal.getAttribute('data-label-sold-out') || 'Sold out',
  };

  var state = {
    triggerBtn: null,
    product: null,
    selectedVariantId: null,
    isSubmitting: false,
  };

  function normalizeOptions(product) {
    var raw = product.options || [];
    if (!raw.length) return [];

    if (typeof raw[0] === 'string') {
      return raw.map(function (name, index) {
        var position = index + 1;
        var values = [];
        var seen = {};

        (product.variants || []).forEach(function (variant) {
          var value = variantOptionValue(variant, position);
          if (value && !seen[value]) {
            seen[value] = true;
            values.push(value);
          }
        });

        return { name: name, position: position, values: values };
      });
    }

    return raw;
  }

  function getSizeOption(product) {
    var options = normalizeOptions(product);
    for (var i = 0; i < options.length; i++) {
      if (isSizeOption(options[i].name)) return options[i];
    }
    return null;
  }

  function getColorOption(product) {
    var options = normalizeOptions(product);
    for (var i = 0; i < options.length; i++) {
      if (isColorOption(options[i].name)) return options[i];
    }
    return null;
  }

  function isSizeOption(name) {
    var n = String(name || '').toLowerCase();
    return n.indexOf('size') !== -1 || n.indexOf('taille') !== -1;
  }

  function isColorOption(name) {
    var n = String(name || '').toLowerCase();
    return n.indexOf('color') !== -1 || n.indexOf('colour') !== -1 || n.indexOf('couleur') !== -1;
  }

  function getCardColor(card) {
    if (!card) return null;
    var checked = card.querySelector('input[type="radio"]:checked[name*="-swatch"]');
    if (!checked) return null;
    return checked.getAttribute('data-option-value') || checked.value || null;
  }

  function variantOptionValue(variant, position) {
    if (position === 1) return variant.option1;
    if (position === 2) return variant.option2;
    if (position === 3) return variant.option3;
    return null;
  }

  function filterVariants(product, colorValue, colorPosition) {
    return (product.variants || []).filter(function (variant) {
      if (!colorValue || !colorPosition) return true;
      return variantOptionValue(variant, colorPosition) === colorValue;
    });
  }

  function findVariant(product, colorValue, colorPosition, sizeValue, sizePosition) {
    return (product.variants || []).find(function (variant) {
      if (colorValue && colorPosition && variantOptionValue(variant, colorPosition) !== colorValue) return false;
      if (sizeValue && sizePosition && variantOptionValue(variant, sizePosition) !== sizeValue) return false;
      return true;
    });
  }

  function updateCart(cart) {
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          data: { source: 'vetro-card-atc', itemCount: cart.item_count },
        },
      })
    );
  }

  function addVariantToCart(variantId, btn) {
    if (!variantId || state.isSubmitting) return Promise.resolve();

    state.isSubmitting = true;
    if (btn) btn.classList.add('is-loading');
    if (submitBtn) submitBtn.disabled = true;

    var body = new FormData();
    body.append('id', variantId);
    body.append('quantity', '1');

    return fetch('/cart/add.js', {
      method: 'POST',
      body: body,
      headers: { Accept: 'application/json' },
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (data.status) {
          console.error(data.description || data.message);
          return null;
        }
        return fetch('/cart.js').then(function (r) {
          return r.json();
        });
      })
      .then(function (cart) {
        if (cart) updateCart(cart);
        return cart;
      })
      .catch(function (err) {
        console.error(err);
      })
      .finally(function () {
        state.isSubmitting = false;
        if (btn) btn.classList.remove('is-loading');
        if (submitBtn) submitBtn.disabled = false;
      });
  }

  function closeModal() {
    modal.hidden = true;
    document.body.style.overflow = '';
    state.triggerBtn = null;
    state.product = null;
    state.selectedVariantId = null;
  }

  function selectSize(sizeValue, sizePosition, colorValue, colorPosition) {
    var buttons = sizeOptionsEl.querySelectorAll('.vetro-card-atc-modal__size-option');
    buttons.forEach(function (button) {
      button.classList.toggle('is-selected', button.getAttribute('data-size-value') === sizeValue);
    });

    var variant = findVariant(state.product, colorValue, colorPosition, sizeValue, sizePosition);
    state.selectedVariantId = variant && variant.available ? String(variant.id) : null;

    if (submitBtn) {
      submitBtn.disabled = !state.selectedVariantId;
      submitBtn.textContent = state.selectedVariantId ? labels.add : labels.soldOut;
    }
  }

  function renderSizeOptions(product, colorValue, colorPosition) {
    var sizeOption = getSizeOption(product);
    if (!sizeOption) return false;

    var variants = filterVariants(product, colorValue, colorPosition);
    var sizePosition = sizeOption.position;
    var sizes = [];
    var seen = {};

    sizeOption.values.forEach(function (sizeValue) {
      if (seen[sizeValue]) return;
      seen[sizeValue] = true;
      var variant = findVariant(product, colorValue, colorPosition, sizeValue, sizePosition);
      sizes.push({
        value: sizeValue,
        available: Boolean(variant && variant.available),
        variantId: variant ? String(variant.id) : null,
      });
    });

    sizeOptionsEl.innerHTML = '';
    sizes.forEach(function (size) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'vetro-card-atc-modal__size-option';
      button.textContent = size.value;
      button.setAttribute('data-size-value', size.value);
      button.disabled = !size.available;
      button.addEventListener('click', function () {
        selectSize(size.value, sizePosition, colorValue, colorPosition);
      });
      sizeOptionsEl.appendChild(button);
    });

    sizesLabel.textContent = sizeOption.name || labels.size;
    sizesWrap.hidden = sizes.length === 0;

    var firstAvailable = sizes.find(function (s) {
      return s.available;
    });
    if (firstAvailable) {
      selectSize(firstAvailable.value, sizePosition, colorValue, colorPosition);
    } else {
      state.selectedVariantId = null;
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = labels.soldOut;
      }
    }

    return true;
  }

  function openModal(btn, product) {
    state.triggerBtn = btn;
    state.product = product;

    var card = btn.closest('product-card');
    var colorValue = getCardColor(card);
    var colorOption = getColorOption(product);
    var colorPosition = colorOption ? colorOption.position : null;

    titleEl.textContent = product.title || '';
    descriptionEl.innerHTML = product.description || '';

    var hasSizes = renderSizeOptions(product, colorValue, colorPosition);

    submitBtn.textContent = labels.add;
    submitBtn.disabled = hasSizes ? !state.selectedVariantId : false;

    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    submitBtn.focus();
  }

  function handleCardClick(btn) {
    var handle = btn.getAttribute('data-product-handle');
    if (!handle) return;

    var sizeOption = btn.getAttribute('data-has-size') === 'true';
    if (!sizeOption) {
      var variantId = btn.getAttribute('data-variant-id');
      addVariantToCart(variantId, btn).then(function (cart) {
        if (cart) closeModal();
      });
      return;
    }

    btn.classList.add('is-loading');

    fetch('/products/' + encodeURIComponent(handle) + '.js', {
      headers: { Accept: 'application/json' },
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (product) {
        openModal(btn, product);
      })
      .catch(function (err) {
        console.error(err);
      })
      .finally(function () {
        btn.classList.remove('is-loading');
      });
  }

  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest && e.target.closest('.vetro-card-atc');
      if (btn && !btn.disabled) {
        e.preventDefault();
        e.stopPropagation();
        handleCardClick(btn);
        return;
      }

      if (e.target.closest && e.target.closest('[data-vetro-atc-close]')) {
        e.preventDefault();
        closeModal();
      }
    },
    true
  );

  submitBtn.addEventListener('click', function () {
    if (!state.selectedVariantId) return;
    addVariantToCart(state.selectedVariantId, state.triggerBtn).then(function (cart) {
      if (cart) closeModal();
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hidden) closeModal();
  });

  document.addEventListener(
    'change',
    function (e) {
      var input = e.target;
      if (!input || input.type !== 'radio' || !input.getAttribute('data-variant-id')) return;

      var card = input.closest('product-card');
      var btn = card && card.querySelector('.vetro-card-atc');
      if (!btn) return;

      btn.setAttribute('data-variant-id', input.getAttribute('data-variant-id'));
      btn.disabled = input.getAttribute('data-option-available') === 'false';
    },
    true
  );
})();
